import React from 'react';

import { css } from '@emotion/css';
import { TenantSettingsField } from '@recurrency/core-api-schema/dist/common/tenantSettingsTypes';
import { theme } from 'theme';

import { InfoTooltip } from 'components/Tooltip/InfoTooltip';

export function DisabledTenantSettingFieldDescription({ settingField }: { settingField: TenantSettingsField }) {
  const title = settingField.disableConditionHelp ? (
    <span>{settingField.disableConditionHelp}</span>
  ) : (
    <span>There is a disable condition for this setting that disables it.</span>
  );
  return (
    <>
      <b>DISABLED:</b>{' '}
      <span
        className={css`
          color: ${theme.colors.danger[500]};
        `}
      >
        <InfoTooltip title={title}>This setting is disabled.</InfoTooltip>
      </span>
      <br />
    </>
  );
}
